import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ICRUDOptions } from '@phx-erp/shared';
import { Country, CountrySearchInput, SearchInput } from '../../../generated/generated-types';
import { GenericBaseModelDropDown } from '../../components/genericBaseModelDropDown';
import { CountryService } from '../../services/country.service';

@Component({
  selector: 'app-country-drop-down',
  templateUrl: './country-drop-down.component.html',
  providers: [CountryService],
  standalone: true,
  imports: [
    CommonModule,
  ]
})
export class CountryDropDownComponent extends GenericBaseModelDropDown<Country> implements OnInit {

  constructor(
    private countryService: CountryService
  ) {
    super(countryService, "Country");
  }

  ngOnInit(): void {
    if (this.props.isoMode)
      this.optionValueSig.set("identifier");
    super.ngOnInit();
  }

  override async executeSearch(searchInput: SearchInput, options?: ICRUDOptions) {
    let si: CountrySearchInput = searchInput;
    si.onlyEU = this.props.onlyEU;
    return super.executeSearch(searchInput, options);
  }

}
